import React from 'react';

import { InputField } from 'basics';

import { FilterContainer } from 'components/ToolBar/styles';

export default function CompetitionToolbar({ updateFiltering }) {

	const handleYearFilter = (field, value) => {
		updateFiltering(field, 'equals', value.length === 4 ? value : undefined);
	};

	return (
		<FilterContainer>
			<InputField
				label="Filtrar por año"
				type="number"
				id="title"
				placeholder="ingrese el año"
				onChange={handleYearFilter}
			/>
		</FilterContainer>
	);
}
